import { render, staticRenderFns } from "./DocumentNewFrProject.vue?vue&type=template&id=b5f00d4a"
import script from "./DocumentNewFrProject.vue?vue&type=script&lang=js"
export * from "./DocumentNewFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports